import React from "react";
import "./CreateWeekOffModal.css";

function CreateWeekOffModal({
 weekOffForm,
 setWeekOffForm,
 handleCreateWeekOff,
 setShowWeekOffModal,
}) {
 return (
  <div className="createWeekOffModalPage-overlay">
   <div className="createWeekOffModalPage-modal">
    <div className="createWeekOffModalPage-header">
     <div>
      <p className="createWeekOffModalPage-eyebrow">Schedule Break</p>
      <h3 className="createWeekOffModalPage-title">Create Week Off</h3>
      <p className="createWeekOffModalPage-subtitle">
       Add a date when this league will not have games.
      </p>
     </div>

     <button
      type="button"
      className="createWeekOffModalPage-closeBtn"
      onClick={() => setShowWeekOffModal(false)}
     >
      ×
     </button>
    </div>

    <form className="createWeekOffModalPage-form" onSubmit={handleCreateWeekOff}>
     <label className="createWeekOffModalPage-field">
      <span>Date</span>
      <input
       type="date"
       value={weekOffForm.date}
       onChange={(e) =>
        setWeekOffForm((prev) => ({
         ...prev,
         date: e.target.value,
        }))
       }
       required
      />
     </label>

     <label className="createWeekOffModalPage-field">
      <span>Reason <em>(optional)</em></span>
      <input
       type="text"
       value={weekOffForm.reason}
       onChange={(e) =>
        setWeekOffForm((prev) => ({
         ...prev,
         reason: e.target.value,
        }))
       }
       placeholder="Holiday, gym unavailable, league break..."
      />
     </label>

     <div className="createWeekOffModalPage-footer">
      <button
       type="button"
       className="createWeekOffModalPage-cancelBtn"
       onClick={() => setShowWeekOffModal(false)}
      >
       Cancel
      </button>

      <button
       type="submit"
       className="createWeekOffModalPage-primaryBtn"
      >
       Create Week Off
      </button>
     </div>
    </form>
   </div>
  </div>
 );
}

export default CreateWeekOffModal;